// Copyright (c) 2024 Deere & Company

const updateAmountOfUseFilterOptions = [
    ['pin'],
    ['dealer', 'name'],
    ['dealer', 'location', 'city'],
    ['dealer', 'location', 'state'],
    ['dealer', 'account']
];

export default updateAmountOfUseFilterOptions;



// WEBPACK FOOTER //
// ./src/tcsm/wip/services/update-amount-of-use-filter-options.js